import React from "react"

import { Link } from "gatsby"
import { useLocation } from '@reach/router'

import SocialLinks from "../socialLinks/socialLinks.js"
import Logo from "../logo/logo.js"

import QRCodeModalButton from "../qrcodeModal/qrcodeModalButton.js";
import { QRCodeModalProvider } from "../qrcodeModal/qrcodeModalContext.js";

import styles from "./sharedFooter.module.scss"
import appStoreImage from "../../images/apple-app-store.svg"
import googlePlayImage from "../../images/android/Google_Play.svg"
import envelope from "../../images/envelope.svg"
import phoneIcon from "../../images/phone-icon.svg"

const SharedFooter = (props) => {
  const location = useLocation();
  const { search } = location;
  const branchLink = props.ccCode ? `sayiDSdmgfb?campaignCode=${props.ccCode}` : "sayiDSdmgfb";

  return (<footer className={styles.root}>
    <div className={styles.navContainer}>
      <div className={styles.logoContainer}>
        <Logo />
      </div>
      <div className={styles.collapsingContainer}>
        <div className={styles.hiddenSmall}>
          <div className={styles.bankNoticeLarge}>
            <p>Banking services provided by Coastal Community Bank, Member FDIC. Till accounts are FDIC insured up to $250,000 per depositor through Coastal Community Bank, Member FDIC. The Till Visa Card is issued by Coastal Community Bank pursuant to license by Visa U.S.A. Inc. Apple®, App Store®, and iPhone® are registered trademarks of Apple Inc.</p>
          </div>
        </div>
        <ul className={styles.listRoot}>
          <li className={styles.listHeading}>
            Company
          </li>
          <li>
            <nav className={styles.collapsingContainer}>
              <ul className={styles.collapsingColumn}>
                <li className={styles.listItem}>
                  <Link to={`/${search}`}>Home</Link>
                </li>
                <li className={styles.listItem}>
                  <Link to={`/about/${search}`}>About</Link>
                </li>
                <li className={styles.listItem}>
                  <Link to={`/blog/${search}`}>Blog</Link>
                </li>

                <li className={styles.listItem}>
                  <a href="http://app.impact.com/campaign-campaign-info-v2/Till.brand" target="_blank" rel="noopener noreferrer">Affiliates</a>
                </li>
              </ul>
              <ul className={styles.collapsingColumn}>
                <li className={styles.listItem}>
                  <Link to={`/careers/${search}`}>Careers</Link>
                </li>
                <li className={styles.listItem}>
                  <Link to={`/policies/${search}`}>Policies</Link>
                </li>
                <li className={styles.listItem}>
                  <Link to={`/press/${search}`}>Press</Link>
                </li>
                <li className={styles.listItem}>
                  <Link to={`/faq/${search}`}>FAQ</Link>
                </li>
              </ul>
            </nav>
          </li>
        </ul>
        <ul className={styles.listRoot}>
          <li className={styles.listHeading}>
            Contact Info
          </li>
          <li className={styles.supportLink}>
            <a href="tel:+14243778615" >
              <img src={phoneIcon} alt="Illustrated Phone" />
              (424) 377-8615
            </a>
          </li>
          <li className={styles.supportLink}>
            <a href="mailto:support@tillfinancial.io" >
              <img src={envelope} alt="Illustrated envelope" />
              support@tillfinancial.io
            </a>
          </li>
        </ul>
      </div>
    </div>
    <ul className={styles.listRoot}>
      <li className={styles.socialContainer}>
        <SocialLinks variant={'Black'} />

        {props.device === "ios" &&
          <a className={styles.appStoreImg} href={`${process.env.BRANCH_BASE_URL}/${branchLink}`} target="_blank" rel="noreferrer">
            <img src={appStoreImage} alt="Download on the App Store" layout="fixed" />
          </a>
        }
        {props.device === "android" &&
          <a className={styles.googlePlayImg} href={`${process.env.BRANCH_BASE_URL}/${branchLink}`} target="_blank" rel="noreferrer">
            <img src={googlePlayImage} alt="Download on the Google Play Store Store" layout="fixed" />
          </a>
        }
        {props.device !== "android" && props.device !== "ios" &&
          <QRCodeModalProvider>
            <div class={styles.footerButtonWrapper}>
              <QRCodeModalButton eventLabel="Shared Footer" />
            </div>
          </QRCodeModalProvider>
        }

      </li>
    </ul>
    <div className={styles.bankNotice}>
      <p>Banking services provided by Coastal Community Bank, Member FDIC. Till accounts are FDIC insured up to $250,000 per depositor through Coastal Community Bank, Member FDIC. The Till Visa Card is issued by Coastal Community Bank pursuant to license by Visa U.S.A. Inc. Apple®, App Store®, and iPhone® are registered trademarks of Apple Inc.</p>
    </div>
    <p className={styles.copyright}>© 2023 Till Financial. All Rights Reserved.</p>
  </footer>)
}

export default SharedFooter
